import { ANY } from '../../common/utils/any';
/**
 * The language a discussion being written is in, kept with the composer's
 * other fields so that it outlives the composer being minimised.
 */
export function composerFields(composer) {
  return composer.attrs.composer.fields;
}

/**
 * fof/byobu's private discussions have no language.
 */
export function isPrivateComposer(composer) {
  return !!composer._isByobuComposer;
}

/**
 * The code of the language a new discussion starts in: the one the discussion
 * list shows, or the reader's own when the forum is set to start there.
 */
export function startingLanguage(listLanguage, startInLocale, locale) {
  if (listLanguage && listLanguage !== ANY) return listLanguage;
  return startInLocale ? locale : undefined;
}
flarum.reg.add('fof-discussion-language', 'forum/utils/composerLanguage', { composerFields: composerFields,isPrivateComposer: isPrivateComposer,startingLanguage: startingLanguage, });